var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 480,
    viewBox: "0 0 502 518",
    width: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436.81 75.19c-48.48-48.49-112.7-75.19-180.81-75.19s-132.33 26.7-180.81 75.19c-48.49 48.48-75.19 112.7-75.19 180.81s26.7 132.33 75.19 180.81c48.48 48.49 112.7 75.19 180.81 75.19s132.33-26.7 180.81-75.19c48.49-48.48 75.19-112.7 75.19-180.81s-26.7-132.33-75.19-180.81zm-371.04 302.7c-22.63-35.19-35.77-77.03-35.77-121.89 0-124.62 101.38-226 226-226 69.01 0 130.88 31.1 172.37 80.01l-56.76 41.93c-3.45-.62-6.99-.94-10.61-.94h-23.79l-25.6-25.61c-2.82-2.81-6.63-4.39-10.61-4.39h-90c-3.98 0-7.79 1.58-10.61 4.39l-25.6 25.61h-23.79c-33.08 0-60 26.92-60 60v120c0 8.69 1.86 16.95 5.2 24.41zm215.422-159.15c-7.192-4.881-15.863-7.74-25.192-7.74-24.813 0-45 20.187-45 45 0 4.571.701 8.979 1.974 13.138l-24.974 18.451c-4.482-9.607-7-20.306-7-31.589 0-41.355 33.645-75 75-75 19.27 0 36.852 7.317 50.145 19.305zm-25.192 263.26c-69.01 0-130.88-31.1-172.37-80.01l362.6-267.88c22.63 35.19 35.77 77.03 35.77 121.89 0 124.62-101.38 226-226 226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.986 256.55c-.298 41.102-33.815 74.45-74.986 74.45-7.475 0-14.692-1.114-21.511-3.159l-85.435 63.119c.647.021 1.294.04 1.946.04h210c33.08 0 60-26.92 60-60v-120c0-6.54-1.053-12.839-2.997-18.738z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no-photo.e65acacd3322197232b15f0cf95cebbf.svg";
export { ForwardRef as ReactComponent };